import Container from "@amzn/awsui-components-react/polaris/container";
import Header from "@amzn/awsui-components-react/polaris/header";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import BusinessStatusCurrent from "components/BusinessStatusCurrent";
import BusinessStatusHistory from "components/BusinessStatusHistory";
import { BusinessAuditData } from "Types/BusinessAuditTypes";

const BusinessAuditPageResponse = ({ response }: { response: BusinessAuditData }) => {
  const { enrolled, denylisted, vettedMarketplaces, businessId, businessEvents } = response;
  const headerTitle = `Business Audit for Business with ID '${businessId}'`;
  return (
    <Container header={<Header>{headerTitle}</Header>}>
      <SpaceBetween direction="vertical" size="l">
        <BusinessStatusCurrent enrolled={enrolled} vettedMarketplaces={vettedMarketplaces} denylisted={denylisted} />
        <BusinessStatusHistory businessEvents={businessEvents} />
      </SpaceBetween>
    </Container>
  );
};
export default BusinessAuditPageResponse;
